import { BUSINESS_PLAN_TYPES, IBusinessToolType } from 'constants/businessPlan';
import { t } from 'i18next';
import { PDF_SECTIONS } from 'PDF/constants/sections';

export const getAllSectionInfos = (businessPlanType: IBusinessToolType, isExamplePage: boolean) => {
  const isInvestors = businessPlanType === BUSINESS_PLAN_TYPES.FOR_INVESTORS;

  const aboutCompanyHeading = isInvestors
    ? isExamplePage
      ? 'Company and Project'
      : t('chapters.FOR_INVESTORS_COMPANY_AND_PROJECT')
    : isExamplePage
      ? 'About the Company'
      : t('chapters.FOR_BANK_ABOUT_COMPANY');

  const info = {
    [PDF_SECTIONS.SECTION_SUMMARY]: {
      sectionHeading: isExamplePage ? 'Executive Summary' : t('chapters.FOR_BANK_EXECUTIVE_SUMMARY'),
      sectionNumber: '01',
    },
    [PDF_SECTIONS.ABOUT_COMPANY]: {
      sectionHeading: aboutCompanyHeading,
      sectionNumber: '02',
    },
    [PDF_SECTIONS.PRODUCT_AND_SERVICES]: {
      sectionHeading: isExamplePage ? 'Products and Services' : t('chapters.FOR_BANK_PRODUCTS_AND_SERVICES'),
      sectionNumber: '03',
    },
    [PDF_SECTIONS.MARKET_ANALYSIS]: {
      sectionHeading: isExamplePage ? 'Market Analysis' : t('chapters.FOR_BANK_MARKET_ANALYSIS'),
      sectionNumber: isInvestors ? '03' : '04',
    },
    [PDF_SECTIONS.MARKETING_AND_SALES]: {
      sectionHeading: isExamplePage ? 'Marketing and Sales' : t('chapters.FOR_BANK_MARKETING_AND_SALES'),
      sectionNumber: isInvestors ? '04' : '05',
    },
    [PDF_SECTIONS.BUSINESS_OPERATIONS]: {
      sectionHeading: isExamplePage ? 'Business Operations' : t('chapters.FOR_BANK_BUSINESS_OPERATIONS'),
      sectionNumber: isInvestors ? '05' : '06',
    },
    [PDF_SECTIONS.MANAGEMENT_AND_ORGANIZATION]: {
      sectionHeading: isExamplePage
        ? 'Management and Organization'
        : t('chapters.FOR_BANK_MANAGEMENT_AND_ORGANIZATION'),
      sectionNumber: isInvestors ? '06' : '07',
    },
    [PDF_SECTIONS.IMPLEMENTATION_PLAN]: {
      sectionHeading:isExamplePage ? 'Implementation Plan' : t('chapters.FOR_BANK_IMPLEMENTATION_PLAN'),
      sectionNumber: '08',
    },
    [PDF_SECTIONS.RAISING_AND_ALLOCATING_FUNDS]: {
      sectionHeading: isExamplePage
        ? 'Raising and Allocating Funds'
        : t('chapters.FOR_BANK_RAISING_AND_ALLOCATING_FUNDS'),
      sectionNumber: isInvestors ? '07' : '09',
    },
    [PDF_SECTIONS.LEGAL_FRAMEWORK_AND_RISKS]: {
      sectionHeading: isExamplePage ? 'Legal Framework and Risks' : t('chapters.FOR_BANK_LEGAL_FRAMEWORKS_AND_RISKS'),
      sectionNumber: '10',
    },
    [PDF_SECTIONS.FINANCIAL_PLAN]: {
      sectionHeading: isExamplePage ? 'Financial Plan' : t('chapters.FOR_BANK_FINANCIAL_PLAN'),
      sectionNumber: isInvestors ? '08' : '11',
    },
  };

  return info;
};

export const getSectionInfo = (businessPlanType: IBusinessToolType, section: PDF_SECTIONS, isExamplePage: boolean) =>
  getAllSectionInfos(businessPlanType, isExamplePage)[section];
